import { AxiosError } from 'axios';
import { ErrorOption, FieldName } from 'react-hook-form';
import Alert from '@common/alert';

const joinAlert = (setError: (name: FieldName<Record<string, any>>, error: ErrorOption) => void, error: AxiosError) => {
  let title = '서버에 문제가 발생하였습니다.';
  let desc;
  let onOk;

  switch (error?.response?.data.errorCode) {
    case 'B901':
      title = '이미 등록된 아이디와 이메일입니다.';
      desc = '다른 아이디와 이메일을 사용해주세요.';
      onOk = () => {
        setError('userId', { message: '이미 등록된 아이디입니다.' });
        setError('email', { message: '이미 등록된 이메일입니다' });
      };
      break;
    case 'B902':
      title = '이미 등록된 이메일입니다.';
      desc = '다른 이메일을 사용해주세요.';
      onOk = () => {
        setError('email', { message: '이미 등록된 이메일입니다' });
      };
      break;
    case 'B903':
      title = '이미 등록된 아이디입니다.';
      desc = '다른 아이디를 사용해주세요.';
      onOk = () => {
        setError('userId', { message: '이미 등록된 아이디입니다' });
      };
      break;
    case 'B904':
      title = '이미 등록된 휴대폰 번호입니다.';
      desc = '다른 휴대폰 번호를 사용해주세요.';
      break;
    case 'B905':
      title = '이미 가입된 정보가 있습니다.';
      desc = '다시 확인해주세요.';
      break;
    case 'B906':
      title = '20일 이내에 탈퇴한 내역이 존재합니다.';
      desc = '다시 확인해주세요.';
      break;
    case 'B907':
      title = '유효하지 않은 휴대전화 인증번호 입니다.';
      desc = '전화번호 인증부터 다시 시도해주세요.';
      break;
    case 'B908':
      title = 'SMS 인증은 휴대폰 번호가 필수값입니다.';
      desc = '휴대폰 번호를 입력해주세요.';
      break;
    case 'B909':
      title = '세션이 만료되었습니다.';
      desc = '다시 한 번 인증해주세요.';
      break;
    case 'B901':
      title = '비밀번호 양식이 맞지 않습니다.';
      desc = '다른 비밀번호를 사용해주세요.';
      break;
  }

  Alert({
    title,
    desc,
    dimmed: true,
    onOk,
    onClickBgClose: false,
  });
};

export default joinAlert;
